.legend { display: flex; flex-wrap: wrap; gap: 12px; padding: var(--space-2) 8px var(--space-3); font-size: var(--fs-caption); color: var(--content-secondary); }
.item { display: inline-flex; align-items: center; gap: 5px; }
.dot { width: 8px; height: 8px; border-radius: 50%; flex: none; }
